import { GetSoQuery, useGetSoQuery } from 'src/common/api/apollo/additional';

export type RenewalOf = NonNullable<NonNullable<NonNullable<GetSoQuery['getSo']>['productTypeSpecific']>['renewalOf']>;

/**
 * Selfcare renewal context of an SO (health-api `productTypeSpecific.renewalOf`,
 * read through `getSo`). `isRenewal` is true only for a dodatno renewal SO — the
 * regular funnel and the dopunsko comparison never see the renewal screens.
 *
 * @param soId - Encrypted SO id (the `soIdWeb` in Redux, or the `?soId=` / `:soId` param)
 */
export const useRenewalOf = (soId?: string | null) => {
  const { data, loading, refetch } = useGetSoQuery({
    variables: { id: soId ?? '' },
    skip: !soId,
  });
  const so = data?.getSo ?? null;
  const renewalOf = (so?.productTypeSpecific?.renewalOf ?? null) as RenewalOf | null;
  const isRenewal = renewalOf?.productTypeCode === 'dodatno';
  return { so, renewalOf, isRenewal, loading, refetch };
};
